import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Book, CheckCircle2, Clock, CreditCard, ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
const bonusItems = [{
  title: 'Ebook Principal: Vendedor de Hierro',
  desc: 'El paso a paso estratégico para automatizar tu negocio con IA.',
  value: '$25.000',
  image: 'https://cdn.magicpatterns.com/uploads/d16n3rbQXikmx66ZaiSAUN/ChatGPT_Image_9_mar_2026,_04_53_06.png',
  isBonus: false
}, {
  title: 'BONUS 1: Wiki de Prompts para 20 Rubros',
  desc: 'Copiá y pegá el cerebro de tu IA según tu industria. Gastronomía, estética, indumentaria, servicios y más.',
  value: '$15.000',
  image: 'https://cdn.magicpatterns.com/uploads/38yrNsdtKxcFb74v9CE8XP/ChatGPT_Image_9_mar_2026,_05_12_21.png',
  isBonus: true
}, {
  title: 'BONUS 2: Guía Técnica WhatsApp IA desde Cero',
  desc: 'Configuración clic por clic, sin código. Conectá la API oficial de Meta en minutos.',
  value: '$30.000',
  image: 'https://cdn.magicpatterns.com/uploads/8wRi9jSRf9ZK14cJ7BokMk/ChatGPT_Image_9_mar_2026,_05_10_05.png',
  isBonus: true
}, {
  title: 'BONUS 3: Plantillas de Mensajes de Cierre',
  desc: 'Convertí consultas en transferencias al instante con mensajes probados que cierran ventas.',
  value: '$19.900',
  image: 'https://cdn.magicpatterns.com/uploads/hZXt2Kq2EFVyDsGWgsfWV8/ChatGPT_Image_9_mar_2026,_05_08_35.png',
  isBonus: true
}];
function PriceCountdown() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 3,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          minutes: prev.minutes - 1,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="inline-flex items-center gap-2 bg-red-500/15 border border-red-500/30 px-4 py-2 rounded-lg" data-id="element-116">
      <Clock className="w-5 h-5 text-red-500" data-id="element-117" />
      <span className="text-red-500 font-bold text-lg font-mono tabular-nums" data-id="element-118">
        {String(timeLeft.minutes).padStart(2, '0')}:
        {String(timeLeft.seconds).padStart(2, '0')}
      </span>
      <span className="text-red-400 text-sm font-semibold" data-id="element-119">
        restantes a este precio
      </span>
    </div>;
}
export function OfferSection() {
  return <section className="py-14 px-4 relative" data-id="element-120">
      <div className="max-w-5xl mx-auto" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-122">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-123">
            Entregamos el sistema completo para que{' '}
            <span className="text-[#25D366]" data-id="element-124">no tengas que inventar nada</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-125">
            Todo lo que necesitás en un solo paquete
          </p>
        </motion.div>

        {/* Offer Stack */}
        <div className="space-y-5 mb-10" data-id="element-126">
          {bonusItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#111] rounded-2xl border border-white/5 hover:border-[#25D366]/30 transition-colors overflow-hidden" data-id="element-127">
              <div className={`flex flex-col ${item.image ? 'md:flex-row' : ''} items-center gap-6 p-6 md:p-8`} data-id="element-128">
                {/* Mockup Image */}
                {item.image && <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} className="flex-shrink-0 w-48 md:w-56" data-id="element-129">
                    <div className="relative" data-id="element-130">
                      <div className="absolute inset-0 bg-[#25D366]/10 blur-2xl rounded-full -z-10" data-id="element-131" />
                      <img src={item.image} alt={item.title} className="w-full h-auto drop-shadow-[0_10px_30px_rgba(37,211,102,0.15)]" data-id="element-132" />
                    </div>
                  </motion.div>}

                {/* Content */}
                <div className="flex-1 text-center md:text-left" data-id="element-133">
                  <div className="flex flex-col sm:flex-row items-center md:items-start gap-3 mb-3" data-id="element-134">
                    {!item.image && <div className="bg-gradient-to-br from-[#25D366] to-[#00ff41] p-2.5 rounded-lg shadow-[0_0_15px_rgba(37,211,102,0.3)]" data-id="element-135">
                        <Book className="w-6 h-6 text-white" data-id="element-136" />
                      </div>}
                    <div data-id="element-137">
                      <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-138">
                        {item.title}
                      </h3>
                      {item.isBonus && <span className="inline-block mt-2 text-xs font-black bg-[#25D366] text-black px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-139">
                          ✓ GRATIS
                        </span>}
                    </div>
                  </div>
                  <p className="text-gray-400 text-lg leading-relaxed mb-2" data-id="element-140">
                    {item.desc}
                  </p>
                  <div className="flex items-center gap-2 justify-center md:justify-start" data-id="element-141">
                    <span className="text-white font-bold text-sm" data-id="element-142">
                      Valor: <span className="line-through" data-id="element-143">{item.value}</span>
                    </span>
                    {item.isBonus && <span className="text-[#25D366] font-black text-sm" data-id="element-144">
                        → GRATIS
                      </span>}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#111] rounded-3xl border border-[#25D366]/30 p-8 md:p-12 text-center shadow-[0_0_60px_rgba(37,211,102,0.1)]" data-id="element-145">
          <div className="mb-8" data-id="element-146">
            <span className="text-white line-through text-2xl font-bold block mb-3" data-id="element-147">
              VALOR TOTAL: $89.900 ARS
            </span>
            <div className="flex flex-col items-center gap-3" data-id="element-148">
              <span className="text-white text-xl font-bold" data-id="element-149">PRECIO HOY:</span>
              <div className="flex items-center gap-4 flex-wrap justify-center" data-id="element-150">
                <span className="text-6xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#25D366] to-[#00ff41]" data-id="element-151">
                  $19.990
                </span>
                <span className="text-2xl text-[#25D366] font-bold" data-id="element-152">ARS</span>
              </div>
              {/* 3-minute countdown */}
              <PriceCountdown data-id="element-153" />
            </div>
          </div>

          <motion.a href="https://www.ilumente.com/cart/52267256250690:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full md:w-auto group relative inline-flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-black font-black text-xl md:text-2xl px-12 py-6 rounded-xl transition-all shadow-[0_0_30px_rgba(37,211,102,0.4)] hover:shadow-[0_0_50px_rgba(37,211,102,0.6)] no-underline" data-id="element-154">
            SÍ, QUIERO MI CLON DE VENTAS CON IA
            <div className="absolute inset-0 rounded-xl ring-2 ring-white/20 group-hover:ring-white/40 transition-all" data-id="element-155" />
          </motion.a>

          <div className="mt-6 flex flex-wrap justify-center gap-4 text-sm text-gray-400" data-id="element-156">
            <span className="flex items-center gap-1" data-id="element-157">
              <CheckCircle2 className="w-4 h-4 text-[#25D366]" data-id="element-158" /> Pago único
            </span>
            <span className="flex items-center gap-1" data-id="element-159">
              <CheckCircle2 className="w-4 h-4 text-[#25D366]" data-id="element-160" /> Acceso de por
              vida
            </span>
            <span className="flex items-center gap-1" data-id="element-161">
              <CheckCircle2 className="w-4 h-4 text-[#25D366]" data-id="element-162" />{' '}
              Actualizaciones gratis
            </span>
          </div>

          {/* Payment Methods Banner */}
          <div className="mt-10 pt-8 border-t border-white/10" data-id="element-163">
            <img src="https://cdn.magicpatterns.com/uploads/m2qbEjni1aXR1MocUL6ZPx/WhatsApp_Image_2026-03-09_at_5.19.03_AM.jpg" alt="Métodos de pago - Mercado Pago, Visa, Mastercard" className="mx-auto max-w-sm w-full h-auto rounded-xl" data-id="element-164" />
            <p className="text-gray-500 text-xs mt-3 text-center" data-id="element-165">
              Transacción encriptada y protegida
            </p>
          </div>

          {/* 7-Day Guarantee Badge */}
          <div className="mt-10 pt-8 border-t border-white/10 flex flex-col items-center bg-black rounded-2xl p-8 -mx-2" data-id="element-166">
            <img src="https://cdn.magicpatterns.com/uploads/7gRumT5tnvzySjeKaot37a/ChatGPT_Image_10_mar_2026,_00_37_22.png" alt="Garantía 7 Días" className="w-32 h-32 object-contain mb-5" data-id="element-167" />
            <h3 className="text-xl font-black text-white mb-2 text-center" data-id="element-168">
              Garantía de Devolución Total
            </h3>
            <p className="text-gray-400 text-sm text-center max-w-md leading-relaxed" data-id="element-169">
              Si en 7 días sentís que este método no es para vos, te devolvemos
              el <span className="text-white font-bold" data-id="element-170">100% de tu dinero</span>
              . Sin preguntas, sin vueltas. El riesgo es todo nuestro.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}